export default __webpack_public_path__ + "static/media/geld_stapel.40bd5cb5.gif";